import { computed } from 'vue';
import { useFlag } from '@loadsmart/vue-feature-flags';

export function useEnhancedYMSExperience() {
  const featureFlagEnhancedYMSExperience = useFlag('enable-perf-improvements');

  const isEnhancedYMSExperienceEnabled = computed(() =>
    Boolean(featureFlagEnhancedYMSExperience.value?.enabled)
  );

  /**
   * Whether the feature flag has resolved. Used to defer rendering either YMS branch
   * until the flag is known, avoiding a V1->V2 flash and a double chunk fetch.
   */
  const isEnhancedYMSExperienceReady = computed(() =>
    Boolean(featureFlagEnhancedYMSExperience.value?.ready)
  );

  return {
    isEnhancedYMSExperienceEnabled,
    isEnhancedYMSExperienceReady
  };
}
